import { ChatMessage, messageKey } from '../core/protocol/types'

const RUN_GAP_MS = 5 * 60 * 1000

export type LogRow =
  | { readonly kind: 'day'; readonly key: string; readonly timestamp: number }
  | {
      readonly kind: 'message'
      readonly key: string
      readonly message: ChatMessage
      readonly isFirstOfRun: boolean
      readonly isLastOfRun: boolean
    }

function isSameDay(t1: number, t2: number): boolean {
  return new Date(t1).toDateString() === new Date(t2).toDateString()
}

export function buildRows(messages: readonly ChatMessage[]): LogRow[] {
  const rows: LogRow[] = []

  messages.forEach((message, index) => {
    const previous = messages[index - 1]
    const next = messages[index + 1]

    if (!previous || !isSameDay(previous.createdAt, message.createdAt)) {
      rows.push({
        kind: 'day',
        key: `day-${new Date(message.createdAt).toDateString()}`,
        timestamp: message.createdAt,
      })
    }

    const continuesPrevious =
      !!previous &&
      previous.authorId === message.authorId &&
      isSameDay(previous.createdAt, message.createdAt) &&
      message.createdAt - previous.createdAt < RUN_GAP_MS

    const continuesNext =
      !!next &&
      next.authorId === message.authorId &&
      isSameDay(next.createdAt, message.createdAt) &&
      next.createdAt - message.createdAt < RUN_GAP_MS

    rows.push({
      kind: 'message',
      key: messageKey(message),
      message,
      isFirstOfRun: !continuesPrevious,
      isLastOfRun: !continuesNext,
    })
  })

  return rows
}
